module.exports = __webpack_public_path__ + "img/ylands_comp_create_top_1000.427468c8.png";